import { Analytics } from '@nt/xps-analytics';

export default Analytics;
